import { useState } from 'react'

import {
  HoldApprovalControl,
  type HoldApprovalControlProps,
} from '@/components/ui/TowerApprovalControl'
import {
  SlideApprovalControl,
  type SlideApprovalControlProps,
} from '@/components/ui/TowerApprovalControl/SlideApprovalControl.tsx'

type ApprovalMode = 'click_then_slide' | 'hold'

type TowerApprovalControlProps = SlideApprovalControlProps &
  HoldApprovalControlProps & {
    mode?: ApprovalMode
  }

export function TowerApprovalControl({
  onApprove,
  onStartApprove,
  onCancel,
  onCompleted,
  disabled = false,
  confirmationText = 'Slide to confirm',
  buttonText = 'Approve',
  successText = 'Approved successfully',
  mode = 'hold',
  holdDurationMs,
  cycleDurationMs,
}: TowerApprovalControlProps) {
  const [error, setError] = useState<string | null>(null)
  if (mode === 'click_then_slide') {
    return (
      <SlideApprovalControl
        onApprove={onApprove}
        onStartApprove={onStartApprove}
        onCancel={onCancel}
        disabled={disabled}
        confirmationText={confirmationText}
        buttonText={buttonText}
        successText={successText}
        error={error}
        setError={setError}
      />
    )
  }
  return (
    <HoldApprovalControl
      onApprove={onApprove}
      onStartApprove={onStartApprove}
      onCancel={onCancel}
      onCompleted={onCompleted}
      disabled={disabled}
      buttonText={buttonText}
      successText={successText}
      holdDurationMs={holdDurationMs}
      cycleDurationMs={cycleDurationMs}
      error={error}
      setError={setError}
    />
  )
}
